import { render, staticRenderFns } from "./TrainingServices.vue?vue&type=template&id=424a2b9e&scoped=true&"
import script from "./TrainingServices.vue?vue&type=script&lang=js&"
export * from "./TrainingServices.vue?vue&type=script&lang=js&"
import style0 from "./TrainingServices.vue?vue&type=style&index=0&id=424a2b9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a2b9e",
  null
  
)

export default component.exports